import { SelectiveExceptionHandler } from './selective-exception-handler'
import { AuthenticationError } from '../../models'
import { RedirectHelper } from '../../helpers'

export class AuthenticationExceptionHandler extends SelectiveExceptionHandler {

  constructor(private _redirectHelper: RedirectHelper) {
    super()
  }

  public handleError(exception: any, stackTrace?: any, reason?: string) {
    this._redirectHelper.toLoginPage()
  }

  public handledErrors() {
    return [AuthenticationError]
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/authentication-exception-handler.ts